import styled from 'styled-components';

export const Layout = styled.div``;
